import React from 'react';
import numeral from 'numeral';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { getCurrencySymbol, getProductEncodedUrl } from '../../../../helpers';
import { BatchAccountingInfoBlock } from '../BatchAccountingInfoBlock';
import Button from '../../../common/Button';

const MobileLayout = (props) => {
  const {
    setHoverRow,
    getYandexStoreImageMin,
    item,
    quantityEditableClass,
    handleEditBatchOrderItem,
    handleEditItem,
    itemIndex,
    quantityFactEditable,
    ItemTD,
    hoverRow,
    currentSupply,
    quantityFactColor,
    quantityFact,
    quantityDefectiveColor,
    quantityDefective,
    handleRemoveItem,
    isSupplyClosed,
    handleEditSupplyOrder,
    defaultReserve,
    hasRelatedOrder,
    handleEditAccountingAttributes,
  } = props;

  const { checkoutSettings } = useSelector((state) => state.settings);
  const currencySymbol = getCurrencySymbol(checkoutSettings.currency);

  const history = useHistory();
  const currentSupplyItem = currentSupply.planItems[itemIndex];
  return (
    <div
      onMouseEnter={() => setHoverRow(true)}
      onMouseLeave={() => setHoverRow(false)}
      className="main-item"
    >
      <div className="image-wrapper">
        {item.img ? (
          <img alt="" className="image-td" src={getYandexStoreImageMin(item.img, 100)} />
        ) : null}
      </div>
      <div className="data-wrapper">
        <div className="content-sum-wrapper">
          <div className="content-wrapper">
            <Link
              to={{
                pathname: getProductEncodedUrl(item.productId, item.variantId),
                state: { customBackLink: history.location.pathname },
              }}
              className="item-name"
            >
              {item.name}
            </Link>
            {item.article ? <div className="item-article">{`Арт.: ${item.article}`}</div> : null}
            <div className="item-subname">{item.productId}</div>
          </div>
          <div className="sum-wrapper">
            <div className="item-subtitle">План</div>
            <div className="item-sum">
              {numeral(item.price * item.quantity).format('0,0.00')} {currencySymbol}
            </div>
            <div
              className={`${quantityEditableClass} item-quantity`}
              onClick={() => handleEditItem(itemIndex)}
            >
              {item.quantity} шт
            </div>
          </div>
        </div>

        <div>
          {currentSupplyItem?.batchAccountingAttributes ? (
            <BatchAccountingInfoBlock
              isMobile={true}
              itemIndex={itemIndex}
              currentSupplyItem={currentSupplyItem}
              handleEditBatchOrderItem={handleEditBatchOrderItem}
            />
          ) : (
            <>
              {!isSupplyClosed ? (
                <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '100px' }}>
                  <label>Партия</label>
                  <button
                    type="button"
                    className="btn btn-link"
                    style={{ padding: 0, width: '50px' }}
                    onClick={() => handleEditBatchOrderItem(itemIndex)}
                  >
                    Добавить
                  </button>
                  {/*<Button text="Добавить" onClick={() => handleEditBatchOrderItem(itemIndex)} />*/}
                </div>
              ) : null}
            </>
          )}
        </div>

        <div className="item-status item-status-green">
          Факт
          <div
            className={quantityFactEditable ? 'item-price-quantity-editable quantity' : 'quantity'}
            style={{ minWidth: '110px' }}
          >
            Принято:
            {quantityFactEditable ? (
              <ItemTD
                sectionValue={item.quantityRaw}
                sectionName="quantityRaw"
                placeholder="Кол-во"
                hoverRow={hoverRow}
                currentSupply={currentSupply}
                itemIndex={itemIndex}
              />
            ) : (
              <div className={'item-price-quantity ' + quantityFactColor}>{quantityFact || 0}</div>
            )}
            шт
          </div>
        </div>
        {!defaultReserve || (defaultReserve && hasRelatedOrder) ? (
          <div onClick={() => handleEditSupplyOrder(itemIndex, item.orderDocId)}>
            {item.orderDocId ? (
              <div className="add-order">{item.orderDocId}</div>
            ) : (
              <div className="add-order">+ добавить заказ</div>
            )}
          </div>
        ) : null}
        {!isSupplyClosed ? (
          <div className="d-flex">
            <div
              className="add-attribute"
              onClick={() => handleEditAccountingAttributes(itemIndex)}
              style={{ marginTop: '10px', fontSize: '16px' }}
            >
              <i className="mdi mdi-barcode-scan"></i>
            </div>
            <div
              className="item-remove ml-2"
              onClick={() => handleRemoveItem(itemIndex)}
              style={{ marginTop: '10px', fontSize: '16px' }}
            >
              <i className="fe-trash-2" />
            </div>
          </div>
        ) : null}
        {!!quantityDefective && (
          <div className="item-status item-status-red">
            брак
            <div className={'quantity ' + quantityDefectiveColor}>
              Принято: {quantityDefective} шт
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileLayout;
